module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./PayAliQRCodeView.js"));
	}, "PayMentView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PayMentView!./src/pages/Shop/PayMent/PayAliQRCode/PayAliQRCodeView.js
// module id = 1794
// module chunks = 367